import { useEffect } from 'react';
import { useFormikContext } from 'formik';
import { useDebouncedCallback } from 'use-debounce';
export function AutoSave(props) {
    const { debounce = 500 } = props;
    const { values, submitForm, touched, dirty } = useFormikContext();
    const shouldSubmit = () => Boolean(Object.keys(touched).length) || dirty;
    const debouncedSubmit = useDebouncedCallback(() => {
        if (shouldSubmit()) {
            submitForm();
        }
    }, debounce);
    useEffect(() => {
        debouncedSubmit();
    }, [values, debouncedSubmit]);
    return null;
}
